import ReactApexChart from 'react-apexcharts';
import React from 'react';
const UserPieCharts = ({ chartList }) => {
  const stateData = [{}];
  let seriesNew = [];
  let colorNew = [];
  let labelsNew = [];

  chartList?.forEach((element) => {
    if (element.final_amount > 0) {
      seriesNew.push(Math.trunc(element.final_amount));
      colorNew.push('#' + element.color);
      labelsNew.push(element.name);
    }
  });

  stateData.push({
    series: seriesNew,
    options: {
      colors: colorNew,
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: labelsNew,
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  });
  return (
    <>
      <ReactApexChart
        options={stateData[1].options}
        series={stateData[1].series}
        type="pie"
        width={380}
      />
    </>
  );
};

export default UserPieCharts;
